(function () {
    'use strict';

    angular
        .module('bluebookApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('severity', {
                parent: 'entity',
                url: '/severity',
                data: {
                    authorities: [],
                    pageTitle: 'Severities'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/severity/list/severity.html',
                        controller: 'SeverityController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    access: ['Auth', 'ACTIONS', function (Auth, ACTIONS) {
                        var actions = [ACTIONS.ACTION_MAIN_MENU_CONFIG_SEVERITY];
                        return Auth.loadActionsAccess(actions).$promise;
                    }]
                },
                onEnter: ['Auth', 'ACTIONS', 'access', function (Auth, ACTIONS, access) {
                    Auth.checkActionAuthorization(ACTIONS.ACTION_MAIN_MENU_CONFIG_SEVERITY, access);
                }]
            });
    }
})();
